import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SubmissionType } from '../models/support-ticket/enums/SubmissionType.enum';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SupportTicketService {
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {
  }

  submitTicket(data: any, isAuth: boolean): any {
    if (isAuth) {
      return this.http.post(`${environment.apiUrl}/SupportTicket/SubmitTicket`, data);
    } else {
      return this.http.post(`${environment.apiUrl}/SupportTicket/SubmitTicketAsAnonymous`, data);
    }
  }

  getRoles(params: any = null): any {
    return this.http.get(`${environment.apiUrl}/SupportTicket/GetRoles`, { params });
  }

  getSupportTicketCategory(code: SubmissionType): any {
    return this.http.get(`${environment.apiUrl}/SupportTicket/GetSupportTicketCategory?code=${code}`);
  }

  getSupportTicketPriorities(): any {
    return this.http.get(`${environment.apiUrl}/SupportTicket/GetSupportTicketPriorities`);
  }

  getListSupportTickets(params: any): any {
    return this.http.get(`${environment.apiUrl}/SupportTicket/ListSupportTickets`, { params });
  }

  getListSupportTicketByUser(params: any): any {
    return this.http.get(`${environment.apiUrl}/SupportTicket/ListSupportTicketByUser`, { params });
  }

  setTicketPriority(data: any) {
    return this.http.post(`${environment.apiUrl}/SupportTicket/SetTicketPriority`, data);
  }

  changeTicketStatus(data: any) {
    return this.http.post(`${environment.apiUrl}/SupportTicket/ChangeTicketStatus`, data);
  }

  getTicketDetails(id: number) {
    return this.http.get(`${environment.apiUrl}/SupportTicket/GetTicketDetails?Id=${id}`);
  }

  addNote(data: any) {
    return this.http.post(`${environment.apiUrl}/SupportTicket/AddNote`, data);
  }

  getPersonalData(): any {
    return this.http.get(`${environment.apiUrl}/SupportTicket/GetPersonalData`);
  }

  delegateTicket(data: any): any {
    return this.http.post(`${environment.apiUrl}/SupportTicket/DelegateTicket`, data);
  }

  getSupportTicketResolvingReasons(): any {
    return this.http.get(`${environment.apiUrl}/SupportTicket/GetSupportTicketResolvingReasons`);
  }
}
